export default __webpack_public_path__ + "static/NGSwv5HMAFg6IuGlBNMjxLsH8ahuQ2e8-1530bb1a36eb28a6ab3a1393fc5d05bf.woff2";